<template>
  <div class="DevicesNodeInput">
    <div class="DevicesNodeInput-wrapper-rightIcon lxn-h100 lxn-border-round" :class="$store.getters.language.floatClass">
      <ButtonIcon :size="40" bgColor="#ECECEC" :icon="icon" iconColor="#8F8F8F" :padding="8" />
    </div>
    <div class="DevicesNodeInput-wrapper-left lxn-h100 lxn-border-round lxn-overflow-hidden" :class="$store.getters.language.floatClassReverse">
      <div class="DevicesNodeInput-wrapper-leftIcon lxn-h100" :class="$store.getters.language.floatClassReverse" @click="$router.push('/Input' + input.type + 'Settings/' + node.uuid + '/' + index)">
        <ButtonIcon :size="40" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="8" />
      </div>
      <div class="DevicesNodeInput-name lxn-h100 lxn-overflow-hidden lxn-text" :class="[$store.getters.language.floatClass, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]">
        {{input.name}}
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'

export default {
  name: 'NodeInput',
  props: {
    index: Number,
    nodeIndex: Number
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
    }
  },
  computed: {
    node: function() {
      return this.$store.state.nodes[this.nodeIndex];
    },
    input: function() {
      return this.node.inputs[this.index];
    },
    name: function() {
      return this.input.name;
    },
    icon: function() {
      return this.input.icon;
    }
  },
  methods: {
  }
}
</script>

<style>
  .DevicesNodeInput {
    margin-top: 10px;
    height: 50px;
  }
  .DevicesNodeInput-wrapper-rightIcon {
    width: 50px;
    background-color: #DEDEDE;
    padding: 5px;
  }
  .DevicesNodeInput-name {
    line-height: 50px;
    width: calc(100% - 50px);
    text-indent: 5px;
  }
  .DevicesNodeInput-wrapper-left {
    width: calc(100% - 55px);
    background-color: #ECECEC;
  }
  .DevicesNodeInput-wrapper-leftIcon {
    padding: 5px;
  }
</style>
